import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import CSelect from '@/components/CForm/CSelect'
import CRadio from '@/components/CForm/CRadio'
import {dpeprovincelistindex} from "../../../../utils/dpedatadef";
import './index.scss'
import {Spin,Pagination} from "antd";
import { tbjdHanndler } from "@/servers/goodsManageApi";
import {withRouter} from "react-router-dom";
@CBaseComponent
class GoodsManageList extends Component{
    constructor(props) {
        super(props);
        this.getListData = this.getListData.bind(this);
        this.onChange = this.onChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        // reload时重新加载数据
        // this.getListData();
    }


    state = {
        dataSource: [],
        dataSourceHeader: [],
        dataSourceAll:[],
        loading: true,
        levelid: '',
        provinceid:'-1',
        citylist:[],
        options:[
            {
                "name": "全部",
                "id": '',
                "value": "",
            },
            {
                "name": "一级",
                "id": "1410",
                "value": "1410",
            },
            {
                "name": "二级",
                "id": "1411",
                "value": "1411",
            },
            {
                "name": "三级",
                "id": "1412",
                "value": "1412",
            }
        ],
        page: {
            total: 0,
            page: 1,
            pageSize: 10
        },
    };


    onChange(name,data){
        this.setState({
            [name]:data
        })
    }

    onTableChange(data){
        console.log(data);
        this.setState({
            page:{...this.state.page,page:data}
        },()=>{
            let d = JSON.parse(JSON.stringify(this.state.dataSourceAll))
            var bIndex = (parseInt(this.state.page.pageSize) * (parseInt(this.state.page.page) - 1));
            var eIndex = parseInt(bIndex) + (parseInt(this.state.page.pageSize));
            var newDataList = [];
            for(var i = bIndex;i < eIndex;i++){
                if (d[i]) {
                    newDataList.push(d[i]);
                }
            }
            this.setState({
                dataSource:newDataList
            })
        })

    }
    onShowSizeChange(pageSize){
        this.setState({
            page:{...this.state.page,pageSize:pageSize}
        },()=>{
            let d = JSON.parse(JSON.stringify(this.state.dataSourceAll))
            var bIndex = (parseInt(this.state.page.pageSize) * (parseInt(this.state.page.page) - 1));
            var eIndex = parseInt(bIndex) + (parseInt(this.state.page.pageSize));
            var newDataList = [];
            for(var i = bIndex;i < eIndex;i++){
                if (d[i]) {
                    newDataList.push(d[i]);
                }
            }
            this.setState({
                dataSource:newDataList
            })
        })
    }



    // 获取用户列表数据
    getListData(){
        this.setState({
            loading: true
        });
        const params = {
            levelid:this.state.levelid,
            provinceid:this.state.provinceid === '-1' ? '' : this.state.provinceid,
        }
        tbjdHanndler(params).then(res=>{
            if (res.statecode === 0) {
                let d = JSON.parse(JSON.stringify(res.records[0].datalist))
                let d1 = JSON.parse(JSON.stringify(res.records[0].datalist))
                d.splice(0, 1);
                d1.splice(0, 1);
                let  data = d.splice((this.state.page.page-1)*this.state.page.pageSize,this.state.page.page*this.state.page.pageSize)
                console.log(res.records[0].datalist[0]);
                this.setState({
                    dataSourceHeader: res.records[0].datalist[0],
                    dataSource: data,
                    dataSourceAll:d1,
                    loading:false,
                    page:{...this.state.page,total:d.length}
                });
            }
        }).catch(err=>{
            console.log(err,'rttt')
        })
    }
    componentWillMount(){

    }

    componentDidMount(){
        dpeprovincelistindex.forEach(item=>{
            item.value = item.id
        })
        // dpeprovincelist.unshift({"id":"-1","name":"全部",'value':'-1'})
        this.setState({
            citylist:dpeprovincelistindex
        })
        this.getListData();
    }

    render(){
        return (
            <Spin spinning={this.state.loading}>
            <div className='user-manage-list'>
                <div className='flex filter-wrap'>
                    <div className='filter-left' style={{width:'100%'}}>
                        <div style={{marginBottom:'10px'}}>
                            <label htmlFor="">
                                质量等级：</label>
                            <CRadio value={this.state.levelid}
                                    options={this.state.options}
                                    onChange={(e)=>{this.onChange('levelid',e)}}
                            />
                        </div>
                        <div style={{marginBottom:'10px'}}>
                            <label htmlFor="">
                                博物馆所处省份：</label>
                            <CSelect
                                value={this.state.provinceid}
                                options={this.state.citylist}
                                placeholder='请选择所处省份'
                                onChange={(e)=>{this.onChange('provinceid',e)}}
                                style={{width:'100px'}}
                            />
                        </div>
                        <CButton type='primary' onClick={()=>{this.getListData()}}>查询</CButton>
                    </div>
                </div>
                <div style={{display:'flex',borderBottom:'1px solid #bebebe',marginTop:'20px'}}>
                {
                    this.state.dataSourceHeader.map((item,index1)=>{
                        return (
                             <div style={{flex:1,textAlign:'center',marginBottom:'10px',alignItems:'center',width:item ==0?'20px':'auto'}}>{item}</div>
                       )
                    })
                }
                </div>
                {
                    this.state.dataSource.map((item,index1)=>{
                        return (<div style={{display:'flex',borderBottom:'1px solid #bebebe',marginTop:'20px'}}>
                            {
                                item.map((item2,index2)=>{
                                    return <div style={{flex:1,textAlign:'center',marginBottom:'10px',alignItems:'center',width:index2 ==0?'20px':'auto'}}>{item2}</div>
                                })
                            }
                        </div>)
                    })
                }
                <Pagination
                    style={{marginTop:'20px'}}
                    total={this.state.dataSourceAll.length}
                    current={this.state.page.page}
                    showSizeChanger
                    showQuickJumper
                    onChange={(pageNumber)=>{this.onTableChange(pageNumber)}}
                    onShowSizeChange={(page,pageSize)=>{this.onShowSizeChange(pageSize)}}
                    // showTotal={(total) => `Total ${total} items`}
                />
            </div>
            </Spin>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        // reload: state.reload,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        // setReload: bindActionCreators(setReload, dispatch)
    }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
